export default __webpack_public_path__ + "static/media/client-20.f8d467d7.webp";